import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const cx = useMotionValue(-100);
  const cy = useMotionValue(-100);
  const sx = useSpring(cx, { stiffness: 400, damping: 32, mass: 0.4 });
  const sy = useSpring(cy, { stiffness: 400, damping: 32, mass: 0.4 });
  const [hover, setHover] = useState(false);
  const [pointer, setPointer] = useState(false);
  const raf = useRef(0);

  useEffect(() => {
    const hasFinePointer = window.matchMedia("(pointer: fine)").matches;
    if (!hasFinePointer) return;
    setPointer(true);

    const move = (e) => {
      cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        cx.set(e.clientX);
        cy.set(e.clientY);
      });
    };
    const enter = (e) => {
      const t = e.target;
      if (!t?.closest) return;
      if (t.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']")) {
        setHover(true);
      }
    };
    const leave = (e) => {
      const t = e.target;
      if (!t?.closest) return;
      if (t.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']")) {
        setHover(false);
      }
    };
    window.addEventListener("mousemove", move, { passive: true });
    document.addEventListener("mouseover", enter, true);
    document.addEventListener("mouseout", leave, true);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", enter, true);
      document.removeEventListener("mouseout", leave, true);
      cancelAnimationFrame(raf.current);
    };
  }, [cx, cy]);

  if (!pointer) return null;

  return (
    <>
      <motion.div
        aria-hidden
        style={{ x: sx, y: sy }}
        className="pointer-events-none fixed left-0 top-0 z-[100] -translate-x-1/2 -translate-y-1/2"
      >
        <motion.div
          animate={{ scale: hover ? 1.8 : 1, opacity: hover ? 0.9 : 0.7 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="h-6 w-6 rounded-full border border-bht-gold/60 mix-blend-difference"
        />
      </motion.div>
      <motion.div
        aria-hidden
        style={{ x: cx, y: cy }}
        className="pointer-events-none fixed left-0 top-0 z-[100] -translate-x-1/2 -translate-y-1/2"
      >
        <div className="h-1 w-1 rounded-full bg-bht-gold" />
      </motion.div>
    </>
  );
}
